<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 5px;font-size: 22px;text-align: center;font-weight: bold;margin-top: 20px;">
          填表人需要正确录入哪列数据才能领取自己的表格,请按照下面三步要求设置！
        </div>
        <div style="padding: 10px;display:flex;align-items:center;flex-direction: column;">

          <div width="100%" style="text-align: center;font-size:20px;padding-bottom: 20px;">
            <div style="font-size:18px;margin-bottom: 10px;font-weight: bold;">
              <span style="color:red;">第一步</span>.选择填表人领表时要填写的内容列名(如：姓名、工号等)
            </div>

            <div style="margin-top: 10px;width:600px;">
              <div style="font-size: 14px;"><span style="margin-bottom: 10px;">*请从左框中把填表人领表时需要填写的列(如姓名,身份证等,<span
                    style="color:red;">最多两个</span>)选到右侧框中.</span></div>
              <div style="text-align: left;display: flex;justify-content: center;margin-top: 10px;">
                <el-transfer @change="selectChange" v-model="selectedCondition" :data="transferList"
                  :titles="['可选的列','已选的列']"></el-transfer>
              </div>
            </div>

            <div style="margin-top: 20px;" v-if="selectedCondition.length>0">
              <div style="font-size: 20px;color:red;margin-top: 10px;">
                <el-checkbox v-model="show_public" @change="checkPublic"><span
                    style="color:red;font-size: 16px;">{{showPublicTips()}}</span>
                </el-checkbox>
              </div>
            </div>

            <div style="margin-top: 20px;" v-if="selectedCondition.length>0">
              <div style="font-size: 16px;color:red;margin-top: 10px;">
                填表人领表效果如右图所示,如无误点右侧的红色按钮完成设置
              </div>
            </div>

          </div>

          <div style="margin-left: 30px;padding-bottom: 20px;display: flex;flex-direction: column;">
            <div style="text-align: center;font-size: 18px;font-weight: bold;"><span
                style="color:red;">第二步</span>.预览填表人领表时会看到的界面效果
            </div>
            <div style="font-size: 14px;display: flex;justify-content: center;margin-top: 5px;"><span
                style="margin-bottom: 10px;text-align: center;">填表人领表时需要填写以下内容才可领取表格,请查看是否满足领表要求</span></div>
            <div style="display:flex; flex-direction: column; justify-content: center;margin-top: 20px;">
              <div style="display:flex; justify-content: center;flex-direction: column;">
                <div style="display: flex;justify-content: center;"><el-image style="width: 300px; height: 400px;"
                    :src="search_face_url" fit="fit"></el-image></div>


                <div style="position: relative;left:0px;top:-330px;display: flex;justify-content: center;">
                  <span style="font-size: 16px;font-weight: bold;">{{form_name}}</span>
                </div>

                <div style="display: flex;flex-direction: column;">
                  <div style="position: relative;left:80px;top:-395px; " v-if="selectedCondition.length==0">
                    <div style="font-size: 16px;"></div>
                  </div>
                  <div style="position: relative;left:80px;top:-330px; " v-else-if="selectedCondition.length==1">
                    <div style="font-size: 14px;font-weight: bold;">{{selectedCondition[0]}}:</div>
                  </div>
                  <div style="position: relative;left:80px;top:-330px; " v-else-if="selectedCondition.length==2">
                    <div style="font-size: 14px;font-weight: bold;">{{selectedCondition[0]}}:</div>
                    <div style="font-size: 14px;font-weight: bold;margin-top: 55px;">{{selectedCondition[1]}}:</div>
                  </div>
                </div>

              </div>



            </div>
          </div>

          <div style="text-align: center;padding-bottom: 20px;">
            <div style="font-size:18px;margin-bottom: 10px;font-weight: bold;">
              <span style="color:red;">第三步</span>.完成设置并导入数据
            </div>
            <div style="font-size: 14px;">
              如果上面的条件设置正确，请点“完成设置，返回列表”;如果不需要设置条件，请点“不设条件,需要全部填写”。
            </div>

            <div style="padding: 10px;text-align: center;display: flex;justify-content: center;flex-direction: row;">
              <el-button type="danger" size="medium" @click="returnFormList">放弃导入,返回列表</el-button>

              <el-button type="primary" size="medium" @click="saveConfiguration">完成设置，返回列表</el-button>
            </div>
            <!--         <div style="padding: 10px;text-align: center;display: flex;justify-content: center;">

            </div> -->
          </div>

        </div>

      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>

        <div>
          {{message}}
        </div>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="primary">好 的</el-button>
      </span>
    </el-dialog>

    <el-dialog title="操作确认" :visible.sync="setConditionConfirmVisible" width="40%">
      <span>

        <div>
          领表时,填表人填写的<span
            style="color:red;font-weight: bold;">{{selected_column_names}}</span>必须与表中已有的数据一致才能领表,不一致将无法领取表格,是吗?
        </div>

      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setConditionConfirmVisible = false">取消</el-button>
        <el-button @click="confirmImport" type="primary">是的,立即导入</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        username: '',
        form_name: '',
        form_id: '',
        form_comment: '',
        dataList: [],
        headList: [],

        transferList: [],
        selectedCondition: [],

        input_pages: '',
        import_data: '',
        dialogVisible: false,
        message: '',
        show_public: false,
        is_public: 0,

        setConditionConfirmVisible: false,
        selected_column_names: '',

        search_face_url: '/form/images/p1.jpg'
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      console.log('表格名称是：', this.form_name)

      this.loadTransferList()
    },
    methods: {
      saveConfiguration() {
        if (this.selectedCondition.length === 0) {
          // this.$message.error('至少需要选择一个列用做领表凭证')
          this.message = '至少选一个供填表人输入的列的内容,如编号、姓名等，否则导入的数据填表人无法正确领取修改和填写。'
          // this.dialogVisible = true
          // this.$message.error(this.message)

          this.$alert(this.message, '操作提醒')
          return
        }

        if (this.selectedCondition.length > 2) {
          this.message = '至少选一个供填表人输入的列的内容但不要超过两个,否则填写会比较麻烦,如编号、姓名等，否则导入的数据填表人无法正确领取修改和填写。'
          // this.$message.error(this.message)

          this.$alert(this.message, '操作提醒')
          return
        }

        // if (this.selectedCondition.length > 2) {
        //   this.$message.error('最多选择两个列哦')
        //   return
        // }

        // console.log('&&&&&&&&&&&&&&&&&&', this.is_public)

        this.setConditionConfirmVisible = true

        /* let that = this

         var requestUrl = '/form/web/_save_valid_configuration.jsp'
         // 开启loading

         // 开启loading
         const load = this.$loading({
           lock: true,
           text: 'Loading',
           spinner: 'el-icon-loading',
           background: 'rgba(0, 0, 0, 0.7)'
         })

         var jsonStr = JSON.stringify(that.selectedCondition)

         if (this.show_public === true) {
           this.is_public = 1
         } else {
           this.is_public = 0
         }

         let data = {
           form_id: that.form_id,
           conditions: jsonStr,
           is_public: that.is_public
         }

         var qs = require('qs')

         this.axios.post(
             requestUrl,
             qs.stringify(data), {
               headers: {
                 'Content-Type': 'application/x-www-form-urlencoded'
               }
             }
           ).then(function(response) {
             if (response.data.result === '1') {
               that.$message.success('保存成功！')
               that.$router.push({
                 path: '/form_list',
                 params: {
                   username: that.username
                 }
               })
             }

           })
           .catch(function(error) {
             console.log(error)
             load.close()
           }) */
      },
      back() {
        this.$router.back()
      },
      backToList() {
        let that = this
        that.$router.push({
          path: '/form_list',
          params: {
            username: that.username
          }
        })
      },
      loadTransferList() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/form/web/_load_transfer_field_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(response) {
            that.transferList = []
            let items = response.data.formFields
            for (var i = 0; i < items.length; i++) {
              var tmpLabel = items[i].field_name + '(' + items[i].valued_count + '条)'
              let item = {
                key: items[i].field_name,
                label: tmpLabel,
                disabled: false
              }
              that.transferList.push(item)
            }

            that.selectedCondition = []
            let selectedItems = response.data.selecteFormFields
            for (var j = 0; j < selectedItems.length; j++) {
              // let selectedItem = {
              //   key: selectedItems[j].field_name,
              //   label: selectedItems[j].field_name
              // }
              that.selectedCondition.push(selectedItems[j].condition_name)
            }

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      showPublicTips() {
        let that = this

        var tempstr = ''

        var tstr = ''

        for (var i = 0; i < that.selectedCondition.length; i++) {
          if (i === 0) {
            tstr = that.selectedCondition[0]
          } else {
            tstr = tstr + '、' + that.selectedCondition[i]
          }
        }

        if (tstr !== '') {
          tstr = '"' + tstr + '"'
        }

        this.selected_column_names = tstr

        tempstr = '公开' + tstr + '条件的值,便于领表人填写查询条件'

        return tempstr
      },
      confirmImport() {
        this.setConditionConfirmVisible = false

        let that = this

        var requestUrl = '/form/web/_save_valid_configuration.jsp'
        // 开启loading

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var jsonStr = JSON.stringify(that.selectedCondition)

        if (this.show_public === true) {
          this.is_public = 1
        } else {
          this.is_public = 0
        }

        let data = {
          form_id: that.form_id,
          conditions: jsonStr,
          is_public: that.is_public
        }

        var qs = require('qs')

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            if (response.data.result === '1') {
              that.$message.success('保存成功！')
              that.$router.push({
                path: '/form_list',
                params: {
                  username: that.username
                }
              })
            }
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      selectChange(value) {
        if (this.selectedCondition.length > 2) {
          this.$alert('最多只能选择两个列作为领表查询条件！', '操作提醒')
          this.selectedCondition = this.selectedCondition.slice(0, 2)
        }

        if (this.selectedCondition.length == 1) {
          this.search_face_url = '/form/images/p1.jpg'
        } else if (this.selectedCondition.length == 2) {
          this.search_face_url = '/form/images/p2.jpg'
        } else {
          this.search_face_url = '/form/images/p1.jpg'
        }
      },
      checkPublic(value) {
        console.log('check value=', value)
        if (value == true) {
          this.is_public = 1
        } else {
          this.is_public = 0
        }
      },
      returnFormList() {
        let that = this
        this.$confirm('您确定不导入此表格了吗?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {

          that.removeForm()

        }) // 在这里可以调接口，注意：.then后面要写一个回调函数
      },
      removeForm() {
        let that = this

        // console.log('的的顶顶顶顶顶的顶顶顶顶顶',this.form_id)

        // 调用删除接口
        var requestUrl = '/form/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.backToList()
          })
          .catch(function(error) {
            console.log(error)
          })
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/set_valid_condition.vue